import { render, staticRenderFns } from "./PublicLinkExpired.vue?vue&type=template&id=d7995c6e&"
import script from "./PublicLinkExpired.vue?vue&type=script&lang=js&"
export * from "./PublicLinkExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports